import type { SxProps, Theme } from '@mui/material';

export const DROPZONE_COLORS = {
  border: {
    active: '#3A78F8',
    error: '#D32F2F',
    default: '#E0E0E0',
  },
  background: {
    active: '#3A78F814',
    error: '#D32F2F0A',
    default: '#FAFAFA',
  },
} as const;

export const dropzoneContainerSx: SxProps<Theme> = {
  padding: '24px',
  borderWidth: '2px',
  borderStyle: 'dashed',
  transition: 'all 0.2s ease-in-out',
  gap: '8px',
};

export const uploadButtonSx: SxProps<Theme> = {
  textTransform: 'none',
  borderColor: '#E0E0E0',
  color: '#020f20',
  borderRadius: '8px',
  fontWeight: 500,
  fontSize: '13px',
  padding: '4px 16px',
  '&:hover': {
    borderColor: '#BDBDBD',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
};
